
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { useIsMobile } from "@/hooks/use-mobile";

interface LoanAmountSectionProps {
  loanAmount: number;
  setLoanAmount: (value: number) => void;
}

export const LoanAmountSectionSv = ({ loanAmount, setLoanAmount }: LoanAmountSectionProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="mb-4 md:mb-6 w-full">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-2">
        <Label htmlFor="loan-amount" className="text-gray-800 font-medium mb-1 sm:mb-0 text-sm md:text-base">Lånebelopp</Label>
        <span className="font-semibold text-blue-700 bg-blue-50 px-3 py-1 rounded-full text-sm inline-block mt-1 sm:mt-0">
          {loanAmount.toLocaleString()} €
        </span>
      </div>
      <div className="relative mt-2 p-3 md:p-4 bg-white rounded-lg shadow-sm w-full">
        <Slider 
          id="loan-amount" 
          min={1000} 
          max={70000} 
          step={1000} 
          value={[loanAmount]} 
          onValueChange={(value) => setLoanAmount(value[0])}
          className="w-full my-3"
        />
        <div className="flex justify-between text-xs text-gray-600 font-medium mt-2 w-full">
          <span className="bg-blue-50 px-2 py-1 rounded-full">1 000 €</span>
          <span className="bg-blue-50 px-2 py-1 rounded-full">35 000 €</span>
          <span className="bg-blue-50 px-2 py-1 rounded-full">70 000 €</span>
        </div>
      </div>
    </div>
  );
};
